// extracted by mini-css-extract-plugin
export var featuresSection = "index-module--features-section--dkkpE";
export var featuresSectionWrapper = "index-module--features-section-wrapper--5-cyO";